import { HTTP_TYPES } from '@/lib/enums';
import api from '@/api/api';

const response = {
    async postRequestFetch(
        payload: DepotReviewsRequestFetchRequest
    ): Promise<{ data?: DepotReviewsRequestFetchResponse } | null> {
        // source: tripadvisor | google
        // from_date: datetime
        // fetch_responses_enabled_only: boolean
        // skip_fetch_responses_enabled_profiles: boolean
        // profile_uuid: guid
        // profile_reference: string
        // profile_uuids: guid[]

        return await api(
            HTTP_TYPES.POST,
            `${import.meta.env.VITE_DEPOT_API_REVIEWS}/reviews/request-fetch`,
            payload
        );
    },
    async postDedupeReviews(payload: any): Promise<any> {
        // from_date: datetime
        // to_date: datetime
        // type: string

        return await api(
            HTTP_TYPES.POST,
            `${import.meta.env.VITE_DEPOT_API_REVIEWS}/reviews/dedupe-reviews`,
            payload
        );
    },
    async postResendReviewsMantle(payload: any): Promise<any> {
        // date_from: datetime
        // date_to: datetime
        // profile_uuid: guid

        return await api(
            HTTP_TYPES.POST,
            `${import.meta.env.VITE_DEPOT_API_REVIEWS}/reviews/resend/`,
            payload
        );
    },
    async postGetReviewsByCompany(payload: any): Promise<any> {
        // from_date: datetime
        // to_date: datetime
        // page_size: int
        // id: guid // company uuid
        // continuation_token: string

        return await api(
            HTTP_TYPES.POST,
            `${import.meta.env.VITE_DEPOT_API_REVIEWS}/reviews/company/`,
            payload
        );
    },
    async postGetReviewsByProfile(payload: any): Promise<any> {
        // from_date: datetime
        // to_date: datetime
        // page_size: int
        // id: guid // profile uuid
        // continuation_token: string

        return await api(
            HTTP_TYPES.POST,
            `${import.meta.env.VITE_DEPOT_API_REVIEWS}/reviews/profile/`,
            payload
        );
    },
    async postGetReviews(payload: any): Promise<any> {
        return await api(
            HTTP_TYPES.POST,
            `${import.meta.env.VITE_DEPOT_API_REVIEWS}/reviews/`,
            payload
        );
    },
    /**
     * Export the reviews matching the current filters as CSV. Same endpoint as
     * the search, with `export: true` in the body and a `text/csv` Accept header.
     */
    async postExportReviews(payload: any): Promise<any> {
        return await api(
            HTTP_TYPES.POST,
            `${import.meta.env.VITE_DEPOT_API_REVIEWS}/reviews/`,
            payload,
            undefined,
            'application/json',
            'v1',
            {
                Accept: 'text/csv'
            }
        );
    },
    async getFetchReviewsCount(fromDate?: string, toDate?: string): Promise<any> {
        const params: { from_date?: string; to_date?: string } = {};

        if (fromDate) {
            params.from_date = fromDate;
        }

        if (toDate) {
            params.to_date = toDate;
        }

        return await api(
            HTTP_TYPES.GET,
            `${import.meta.env.VITE_DEPOT_API_REVIEWS}/reviews/count`,
            null,
            params
        );
    },
    async getReviewCountsByDay(days: number = 7): Promise<any> {
        return await api(
            HTTP_TYPES.GET,
            `${import.meta.env.VITE_DEPOT_API_REVIEWS}/reviews/count-by-day`,
            null,
            { days }
        );
    },
    async getReviewCountsByMonthAllProfiles(fromYear?: number, fromMonth?: number): Promise<any> {
        const params: { from_year?: number; from_month?: number } = {};

        if (fromYear !== undefined) {
            params.from_year = fromYear;
        }

        if (fromMonth !== undefined) {
            params.from_month = fromMonth;
        }

        return await api(
            HTTP_TYPES.GET,
            `${import.meta.env.VITE_DEPOT_API_REVIEWS}/reviews/review-counts-by-month-all-profiles-csv`,
            null,
            params
        );
    },
    async getReviewCountsByMonth(fromYear?: number, fromMonth?: number): Promise<any> {
        const params: { from_year?: number; from_month?: number } = {};

        if (fromYear !== undefined) {
            params.from_year = fromYear;
        } else {
            // go back 12 months by default if fromYear is not provided
            const currentDate = new Date();
            currentDate.setFullYear(currentDate.getFullYear() - 1);
            params.from_year = currentDate.getFullYear();
        }

        if (fromMonth !== undefined) {
            params.from_month = fromMonth;
        } else if (fromYear === undefined) {
            // go back 12 months if no fromyear or fromMonth is provided
            const currentDate = new Date();
            currentDate.setMonth(currentDate.getMonth() - 11); // set to 11 months ago to include the current month
            params.from_month = currentDate.getMonth() + 1; // getMonth is zero-based
        }

        return await api(
            HTTP_TYPES.GET,
            `${import.meta.env.VITE_DEPOT_API_REVIEWS}/reviews/counts-by-month`,
            null,
            params
        );
    },
    async getReviewCountsByMonthByProfile(profileUuid: string, fromYear?: number, fromMonth?: number): Promise<any> {
        const params: { profile_uuid: string; from_year?: number; from_month?: number } = {
            profile_uuid: profileUuid
        };

        if (fromYear !== undefined) {
            params.from_year = fromYear;
        }

        if (fromMonth !== undefined) {
            params.from_month = fromMonth;
        }

        return await api(
            HTTP_TYPES.GET,
            `${import.meta.env.VITE_DEPOT_API_REVIEWS}/reviews/counts-by-month-by-profile`,
            null,
            params
        );
    }
};

export default response;
